import myAnswer from "../../popup/index.vue"; //引入每日辟谣组件
import API from "@/utils/axiosApi/powderedMilkApi";
import {
  BuiedPointClick_Fn,
  clarifyrumors_name,
} from "../../../../../assets/js/BuriedPointEvent.js";
import {
  isUserEdit,
  isUserLogin,
  getCookie,
  Debounce,
} from "@/assets/js/common.js";

export default {
  name: "rumorWrap",
  data() {
    return {
      show: false, //是否显示回答
      crmid: "", //传请求查询
      tagid: "", //
      answer: {}, //解析
      title: "", //题目
      id: null, //当前问题id
      userAnswer: null,
      message: null,
      currentBabyNum: "", //宝宝当前胎数
      babyInfo: [],
      currentBabyInfo: {}, //宝宝当前的信息
      rumourData: {}, //数据
    };
  },
  components: {
    myAnswer,
  },
  computed: {
    // 如果babyBuried没值，埋点就自动 就过滤属性
    babyBuried() {
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      return babyBuried ? babyBuried : {};
    },
  },
  methods: {
    //回答是和否    type 1是  0否
    yesAnswer(type) {
      console.log(type, "124");
      console.log(type, 1214);
      this.userAnswer = "";
      localStorage.setItem("type", JSON.stringify(type));
      // 如果是未登录点答题跳到注册页
      if (JSON.parse(localStorage.getItem("userInfo")) == null) {
        location.href = location.origin + "/member/phoneLogin";
        this.show = false;
        this.$emit("showBanner", true);
        return;
      }

      // 每日辟谣答案
      API.getanswer(
        {},
        { id: this.id, userAnswer: type == "是" ? 1 : 0, crmId: this.crmid },
        (res) => {
          if (res.code == "200") {
            this.answer = res.data || {};
            this.show = true;
            this.$emit("showBanner", false);
            // console.log(res.data.answers);
            localStorage.setItem("answer", JSON.stringify(res.data));
          }
        }
      );
      // 答题埋点
      BuiedPointClick_Fn("milkinfo_home_clarifyrumors_click", {
        Baby_Month: this.babyBuried.name,
        click_button: type,
        clarifyrumors_name: this.title,
      });
    },
    ToHistory() {
      this.$router.push({ name: "historylist" });
    },
    //获取question
    getQuestion() {
      // 获取tagid和crmid
      if (isUserEdit()) {
        if (localStorage.getItem("babyNums") == null) {
          let timer = setInterval(() => {
            if (localStorage.getItem("babyNums") != null) {
              clearTimeout(timer);
              this.getQuestion();
            }
          }, 500);
          return;
        } else {
          this.currentBabyNum =
            getCookie("babyNum") || localStorage.getItem("babyNums");
          this.currentBabyInfo = this.babyInfo.find(
            (item) => item.num == this.currentBabyNum
          );
          console.log(this.currentBabyInfo, "currentBabyInfo");
          this.tagid = this.currentBabyInfo.tag_id;
        }
      } else {
        this.tagid = 4;
      }
      // 每日辟谣查询问题
      API.getquestion({ crmId: this.crmid, tagId: this.tagid }, (res) => {
        if (res.code == 200) {
          let { today, complete, CefuteRumorsVO } = res.data;
          this.rumourData = res.data;
          // 已回答完所有的问题，
          if (complete) {
            this.message =
              "哎呦，不错哦！您已经解锁本月龄全部问题啦！快来复习一下吧！";
            return;
          }
          this.title = CefuteRumorsVO.title;
          this.id = CefuteRumorsVO.id;
          if (today) {
            this.answer = CefuteRumorsVO;
            // 显示专家信息及解析
            this.show = true;
            this.$emit("showBanner", false);
          } else {
            this.$emit("showBanner", true);
          }
          // 问题标题曝光
          console.log(clarifyrumors_name, "milkinfo_home_clarifyrumors_expo");
          clarifyrumors_name.observe(
            "milkinfo_home_clarifyrumors_expo",
            ".rumorWrap",
            false,
            {
              clarifyrumors_name: this.title,
            }
          );
        }
        // 问题标题曝光
        console.log(clarifyrumors_name, "milkinfo_home_clarifyrumors_expo");
        clarifyrumors_name.observe(
          "milkinfo_home_clarifyrumors_expo",
          ".question",
          false,
          {
            clarifyrumors_name: this.title,
          }
        );
      });
    },
  },
  watch: {
    handler(show) {
      console.log(show, "567");
    },
  },

  mounted() {
    //请求接口，获取问题答案和解析
    this.crmid = isUserLogin()
      ? ""
      : JSON.parse(localStorage.getItem("userInfo")).crm_id;
    this.babyInfo =
      (isUserEdit() && JSON.parse(localStorage.getItem("babyInfo"))) || [];
    console.log(this.babyInfo, "babyInfo111");
    //获取每日问题
    this.getQuestion();
  },
};
